module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Light.e67b35e.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Light.woff2
// module id = UEpf
// module chunks = 0